//news/[slug].js
import Head from "next/head";
import { useRouter } from "next/router";
import LoadingSpinner from "../../components/common/LoadingSpinner";
import NewsDetails from "../../components/news-details";
import RecentNewsSection from "../../components/recent-news";
import CommonBanner from "../../components/common/CommonBanner";
import Header from "../../components/common/Header";
import Footer from "../../components/footer";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import {
  fetchNewsData,
  fetchNewsDetails,
} from "../../components/http/commonApi";
import HreflangLinks from "../../components/common/HrefLinkTags";

export default function NewsInner({ newsDetails, recentNews }) {
  const router = useRouter();

  if (router.isFallback) {
    return <LoadingSpinner message="Loading news details..." />;
  }
  return (
    <>
      <HreflangLinks
        enPath={`/news/${newsDetails?.slug}`}
        // arPath={`/news/${newsDetails?.slug}`}
        arPath={null}
      />

      {/* {console.log("hasArabic", newsDetails?.hasArabic)}
      <HreflangLinks
        enPath={`/news/${newsDetails?.slug}`}
        arPath={newsDetails?.hasArabic ? `/news/${newsDetails.slug}` : null}
      /> */}

      <Head>
        <title>
          {newsDetails?.metaTitle ||
            "Prism Digital | Top Digital Marketing Agency in UAE"}
        </title>
        <meta
          name="description"
          content={
            newsDetails?.metaDescription ||
            "A leading digital marketing agency in UAE - Prism Digital, offering SEO, PPC, social media, and web design services to grow your brand online. Book us today!"
          }
        />
        <link
          rel="canonical"
          href={`https://www.prism-me.com/news/${newsDetails?.slug}`}
        />
      </Head>
      <Header />
      <main className="w-full box-border bg-background-color-primary overflow-hidden">
        <CommonBanner name={newsDetails?.title} />
        <NewsDetails singleNews={newsDetails} />
        {recentNews?.length > 0 && (
          <RecentNewsSection recentNews={recentNews} />
        )}
      </main>
      <Footer />
    </>
  );
}

export async function getServerSideProps({ params, locale, res }) {
  try {
    const { data: newsDetails } = await fetchNewsDetails(params.slug, locale);

    // ✅ if missing → redirect to news listing
    if (!newsDetails) {
      return {
        redirect: {
          destination: locale === "ar" ? "/ar/news" : "/news",
          permanent: true, // ✅ 308 (SEO-friendly)
        },
      };
    }

    const page = 1;
    const limit = 4;

    const { data: allNews = [] } = await fetchNewsData({
      lang: locale,
      page,
      limit,
    });
    const recentNews = allNews?.items;

    res.setHeader(
      "Cache-Control",
      "public, s-maxage=60, stale-while-revalidate=300",
    );

    return {
      props: {
        newsDetails,
        recentNews,
        ...(await serverSideTranslations(locale, [
          "header",
          "footer",
          "news",
          "common",
        ])),
      },
    };
  } catch (error) {
    console.error("Error in getServerSideProps (news):", error);

    // ✅ if API fails → redirect (temporary is safer)
    return {
      redirect: {
        destination: "/news",
        permanent: false, // ✅ 307
      },
    };
  }
}
